import React from 'react';
import { renderHost } from './renderHost';
import { state } from './state';

export const showUi = (node: React.ReactNode): void => {
    // Cancel any pending final unmount
    if (state.hideTimer !== null) {
        window.clearTimeout(state.hideTimer);
        state.hideTimer = null;
    }

    state.current = { kind: 'content', node };
    // Render hidden first (ensures Fade always has a mount to animate)
    renderHost(false);
    // Next tick -> fade in
    queueMicrotask(() => renderHost(true));
};
